import { User } from "../pages/messaging/types";

export enum TeamMemberRole {
    MEMBER, LEADER, OFFICE_BEARER
}

export interface Member {
    id: number
    user: User,
    functional_area: string,
    role_description: string,
    designation: string,
    // role: string,
    role: TeamMemberRole

}

export interface Team {
    id?: number
    name: string;
    description: string;
    members?: Member[];
    memberIds?: number[]
    selected?: boolean
}

export interface TeamMember {
    userId: number;
    role: TeamMemberRole;
    functionalAreas: string[];
    designation?: string;
}

export interface FunctionalArea {
    id: string;
    name: string;
    description: string;
}
